import { useCallback } from 'react';
import { pick, prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { setCookie } from '@core/js/utils/cookie.util';
import { getBaseDomain } from '@core/js/utils/url.util';
import { publicEventsAPIService } from '@core/js/services/publicEventsAPI.service';
import { storageService } from '@core/js/services/storage.service';
import { useAppSelector, useCookieSettingsSelector } from '@core/js/store/hooks';
import { useShowNotification } from '@core/js/hooks/useShowNotification';
import { useComponentTranslations } from '@core/js/hooks/component/useComponentTranslations';
import { useOnClose } from '@theme/js/components/common/PopupManager';
import { setCommonCookieFlag, setCookiesGroups } from './../components/CookieSettings/store/actions';

import * as helpers from './../helpers';

export const useHandleAccept = (id: string) => {
    const dispatch = useDispatch();
    const translate = useComponentTranslations();
    const closeManagedPopup = useOnClose(id);
    const showNotification = useShowNotification();
    const {
        groupsData,
        defaultCookieName,
        storageCookieName,
        cookieExpirationDays
    } = useCookieSettingsSelector(pick(['groupsData', 'defaultCookieName', 'storageCookieName', 'cookieExpirationDays']));
    const { commonCookieName = defaultCookieName } = useAppSelector(prop('cookiesConfiguration'));

    return useCallback(() => {
        const acceptedCookiesGroups = helpers.getAcceptedCookiesGroups(groupsData);
        dispatch(setCookiesGroups(acceptedCookiesGroups));
        storageService.local.setItem(storageCookieName, acceptedCookiesGroups);

        setCookie(commonCookieName, 1, {
            expires: cookieExpirationDays,
            path: '/',
            domain: getBaseDomain()
        });

        dispatch(setCommonCookieFlag(true));
        publicEventsAPIService.trigger('cookieMessageClosed');
        showNotification(translate('submit.accepted.success'), { variant: 'success' });

        closeManagedPopup();
    }, [
        dispatch,
        translate,
        groupsData,
        storageCookieName,
        commonCookieName,
        cookieExpirationDays,
        showNotification,
        closeManagedPopup
    ]);
};
